import React from 'react';
import I18n from 'i18n-js';
import CsrfForm from '../csrf_form';
import { GOOGLE_AUTH_PATH } from '../url_helpers';
import googleIcon from '../../design-system/icons/vendor/google-color-logo.svg?component';
import { RCTextWithIcon } from '../rc/RCTextWithIcon';
import { RCButton } from '../rc/RCButton';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function GoogleSigninButton(props: Props) {

  const id = 'google-signup-signin';
  const title = props.isSignup
    ? I18n.t('commons.signupForm.googleSignUp')
    : I18n.t('commons.signupForm.googleSignIn');

  return (
    <CsrfForm
      id={id}
      method="post"
      action={GOOGLE_AUTH_PATH.expand({ redirect_to: props.redirectTo })}
    >
      <RCButton
        isSubmit
        fullWidth
        form={id}
        variant="secondary"
      >
        <RCTextWithIcon svgComponent={googleIcon} placement="left">
          {title}
        </RCTextWithIcon>
      </RCButton>
    </CsrfForm>
  );
}
